var Reciever = /** @class */ (function () {
    function Reciever() {
        this._listeners = {};
    }
    Reciever.prototype.setLogger = function (logger) {
        this._logger = logger;
    };
    Reciever.prototype.onmessage = function (e) {
        if (!e.data) {
            return;
        }
        var _a = e.data, cwCmd = _a.cwCmd, cmdId = _a.cmdId, payload = _a.payload;
        if (!cwCmd) {
            return;
        }
        if (this._logger) {
            this._logger.log('Recieved: ', e.data);
        }
        if (this._listeners &&
            this._listeners[cwCmd] &&
            this._listeners[cwCmd].length > 0) {
            this._listeners[cwCmd].forEach(function (handler) { return handler(cmdId, payload); });
        }
    };
    Reciever.prototype.addListener = function (command, handler) {
        if (!Array.isArray(this._listeners[command])) {
            this._listeners[command] = [];
        }
        this._listeners[command].push(handler);
        return handler;
    };
    Reciever.prototype.removeListener = function (command, handler) {
        if (!Array.isArray(this._listeners[command])) {
            return;
        }
        this._listeners[command] = this._listeners[command].filter(function (h) { return h === handler; });
    };
    return Reciever;
}());
var PostMessageable = /** @class */ (function () {
    function PostMessageable() {
        this._reciever = new Reciever();
        this._workerTerminated = false;
        this._postQueue = new Set();
    }
    PostMessageable.prototype.setWorkerTerminated = function (state) {
        var _this = this;
        this._workerTerminated = state;
        if (state === false) {
            // Flush queue when worker is active again
            this._postQueue.forEach(function (_a) {
                var cmdId = _a.cmdId, command = _a.command;
                _this.sendPostMsg(cmdId, command);
            });
            this._postQueue.clear();
        }
    };
    PostMessageable.prototype.sendPostMsg = function (cmdId, command) {
        if (this._workerTerminated) {
            this._postQueue.add({ cmdId: cmdId, command: command });
            return;
        }
        command.cmdId = cmdId;
        var dto = command.toDto();
        this._workerOrWindow.postMessage(dto);
        if (this._logger) {
            this._logger.log('Sent: ', cmdId, dto);
        }
    };
    PostMessageable.prototype.listenFor = function (command, handler) {
        this._reciever.addListener(command, handler);
    };
    PostMessageable.prototype.unlistenFor = function (command, handler) {
        this._reciever.removeListener(command, handler);
    };
    PostMessageable.prototype.setWorker = function (worker) {
        this._workerOrWindow = worker;
        worker.onmessage = this._reciever.onmessage.bind(this._reciever);
    };
    PostMessageable.prototype.setSelf = function (self) {
        this._workerOrWindow = self;
        self.onmessage = this._reciever.onmessage.bind(this._reciever);
    };
    PostMessageable.prototype.setLogger = function (logger) {
        this._logger = logger;
        this._reciever.setLogger(logger);
    };
    return PostMessageable;
}());
export default PostMessageable;
//# sourceMappingURL=postMessageable.js.map